import React, { useState, useContext, useRef, useEffect } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { designActions } from '../../actions';
import { DesignContext } from '../../containers/GraphicBuilder/GraphicBuilder';
import InputRange from 'react-hgs-input-range';
import 'react-hgs-input-range/lib/css/index.css';

const applyVolume = (videoElement, value) => {
  if (!videoElement) return;
  const newVolume = value > 1 ? value / 100 : value;
  if (newVolume < 0.05) {
    videoElement.muted = true;
  } else {
    videoElement.volume = newVolume;
    videoElement.muted = false;
  }
};

const Video = props => {
  const dispatch = useDispatch();
  const [playStatus, setPlayStatus] = useState('pause');
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState({ start: 0, end: 60 });
  const { activePageRef, activeTrimRef, activeVolumeRef } = useContext(DesignContext);

  const video = useRef(null);

  const setToCurrentTime = value => {
    video.current.currentTime = value.value;

    setCurrentTime(value.value);
  };

  const selectedEntity = useSelector(state => state.design.selectedEntity);

  const selectedEntityId = selectedEntity && selectedEntity.id; //!== -1 ? selectedEntity.id : null;
  const activeVolume = activeVolumeRef.current;
  const activeTrimMin = activeTrimRef.current && activeTrimRef.current.min;
  const activeTrimMax = activeTrimRef.current && activeTrimRef.current.max;

  const timeChange = e => {
    setCurrentTime(video.current.currentTime);
    if (_.has(props, 'data.duration')) {
      if (video.current.currentTime < props.data.trim.min) {
        video.current.currentTime = props.data.trim.min;
      }
      if (video.current.currentTime > props.data.trim.max) {
        video.current.currentTime = props.data.trim.min;
      }
    }
  };
  const videoOnLoad = e => {
    if (!_.has(props, 'data.volume')) {
      // newVolumeSet(e.target.volume)
    } else {
      newVolumeSet(props.data.volume);
    }
    if (!_.has(props, 'data.duration')) {
      const duration = e.target.duration;
      setDuration({ start: 0, end: duration });
      const data = {
        duration: duration,
        trim: { min: 0, max: duration },
      };

      dispatch(designActions.changeEntityData(activePageRef.current, props.entityId, data));

      activeTrimRef.current = data.trim;
    } else {
      setDuration({ start: props.data.trim.min, end: props.data.trim.max });
      video.current.currentTime = props.data.trim.min;
      activeTrimRef.current = props.data.trim;
    }
    props.onLoadedData(e);
  };

  const newVolumeSet = value => {
    applyVolume(video.current, value);
  };
  useEffect(() => {
    if (!video.current || props.entityId !== selectedEntityId) return;
    if (activeVolume) applyVolume(video.current, activeVolume);
    if (activeTrimMin && activeTrimMin !== duration.start) {
      video.current.currentTime = activeTrimMin;
      setDuration({ start: activeTrimMin, end: activeTrimMax });
    }
  }, [activeTrimMax, activeTrimMin, activeVolume, duration.start, props.entityId, selectedEntityId]);

  const togglePlay = e => {
    // e.preventDefault();
    if (!video.current.paused) {
      video.current.pause();
      setPlayStatus('pause');
      video.current.volume = 0.5;
    } else {
      setPlayStatus('play');
      setTimeout(() => {
        video.current.play();
      });
    }
  };

  return (
    <span>
      <div className="controller" id={`vController`} data-id={`vc_${props.entityId}`}>
        <div className={`playBtn ${playStatus}`} onMouseDown={togglePlay}></div>
        <InputRange
          minValue={duration.start}
          maxValue={duration.end}
          value={currentTime}
          onChange={value => setToCurrentTime({ value })}
        />
      </div>
      <video
        // muted
        ref={video}
        playsInline
        loop
        data-trim={`${new Date(duration.start * 1000).toISOString().substr(11, 8)},${new Date(
          (duration.end - duration.start) * 1000,
        )
          .toISOString()
          .substr(11, 8)}`}
        data-volume={video.current && video.current.volume}
        type={props.type}
        style={{ display: 'none', position: 'absolute' }}
        onLoadedData={videoOnLoad}
        onTimeUpdate={timeChange}
      >
        <source src={props.src} type="video/mp4" />
      </video>
    </span>
  );
};

export default Video;
